<main>
  <div class="widget-options-container">
    @for (typeKey of itemTypes; track typeKey) {
      <div
        class="widget"
        (click)="add(typeKey)"
        (keydown.enter)="add(typeKey)"
        (keydown.space)="add(typeKey)"
        matTooltip="{{ getTooltip(typeKey) | translate }}"
        [attr.data-cy]="DashboardItemType[typeKey] + '-item'"
        tabindex="0"
      >
        <p><mat-icon svgIcon="{{ getItemTypeIcon(typeKey) }}"></mat-icon></p>
        <p>{{ 'DASHBOARD.TYPE_' + DashboardItemType[typeKey] | translate }}</p>
      </div>
    }
  </div>
</main>
